import { ReactNode } from "react";

import { usePopover, PopoverWrapper, SPACING, Column, IconType } from "@bridgesplit/ui";
import { FilterConfig, FilterProps, isFilterEqual } from "@bridgesplit/abf-react";

import { FilterButton } from "./TableFilterPopover";
import { PopoverContent } from "./common";

type TableAutoFilterPopoverProps<C extends FilterConfig> = {
    children: ReactNode;
    popover: ReturnType<typeof usePopover>;
    onOpen?: () => void;
    filterProps: FilterProps<C>;
    filterKey: keyof C;
    buttonLabel: string;
    buttonIcon?: IconType;
};

export default function TableAutoFilterPopover<C extends FilterConfig>({
    children,
    popover,
    onOpen,
    filterProps,
    filterKey,
    buttonLabel,
    buttonIcon = "filter"
}: TableAutoFilterPopoverProps<C>) {
    const { filters, defaultState, setFilters } = filterProps;

    const isActive = !isFilterEqual(filters[filterKey], defaultState[filterKey]);
    const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
        onOpen?.();
        popover.open(e);
    };

    const handleClear = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();

        setFilters((prev) => ({
            ...prev,
            [filterKey]: defaultState[filterKey]
        }));
        popover.close();
    };

    return (
        <>
            <PopoverWrapper transformOrigin={{ vertical: -1 * SPACING, horizontal: SPACING * 2 }} {...popover}>
                <Column sx={{ width: "250px" }} spacing={0}>
                    <PopoverContent scroll={false}>{children}</PopoverContent>
                </Column>
            </PopoverWrapper>
            <FilterButton
                isActive={isActive}
                onOpen={handleOpen}
                onClear={handleClear}
                label={buttonLabel}
                icon={buttonIcon}
            />
        </>
    );
}
